module.exports = __webpack_public_path__ + "img/民爆行业数字化转型场景图谱.1366dc02.jpg";